import React, { useContext } from 'react';
import { withI18n } from '@lingui/react';
import Collapsible from '~/components/faq/collapsibleElement';
import TransHTML from '~/components/transHTML';
import { LangContext } from '~/providers/LangProvider';
import styled from 'styled-components';

const FAQ = ({ FAQitems }) => {
    const ctxLang = useContext(LangContext);

    return (
        <Wrapper>
            {FAQitems.map((item) => {
                if (item.countries[ctxLang.state.country]) {
                    return (
                        <Collapsible
                            id={item.id}
                            heading={<TransHTML id={item.heading}/>}
                        >
                            <TransHTML id={item.content} />
                        </Collapsible>
                    )
                }
            })}
        </Wrapper>
    );
};

const Wrapper = styled.div`
  width: 100%;
`;

export default withI18n()(FAQ);
